import React, { Suspense, lazy } from 'react';
import { store } from './store';
import { Provider } from 'react-redux';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { AuthProvider } from './Context/AuthContext';
import { ExamModeProvider } from './Context/ExamModeContext';
import ReactDOM from 'react-dom/client';
import Loading from './Components/Logics/Loading';
import 'bootstrap/dist/css/bootstrap-reboot.min.css';
import 'bootstrap/dist/css/bootstrap-grid.min.css';
import 'bootstrap/dist/css/bootstrap-utilities.min.css';
import './base.css';
import RootLayout from './Pages/RootLayout';
import HomePage from './Pages/HomePage';
const ErrorPage = lazy(() => import('./Pages/ErrorPage'));
const ProtectedRoute = lazy(() => import('./Components/Logics/ProtectedRoute'));


// Insert Bootstrap first so route styles keep their overrides on direct loads and refreshes.
const lazyPage = (load) => lazy(async () => {
  await import('bootstrap/dist/css/bootstrap.min.css');
  return load();
});
// Lazy load components
const Dashboard = lazyPage(() => import('./Pages/Dashboard'));
const FirstSecondary = lazyPage(() => import('./Pages/FirstSecondary'));
const SecondSecondary = lazyPage(() => import('./Pages/SecondSecondary'));
const ThirdSecondary = lazyPage(() => import('./Pages/ThirdSecondary'));
const Statistics = lazyPage(() => import('./Pages/Statistics'));
const VideoAccess = lazyPage(() => import('./Pages/VideoAccess'));
const VideoWatch = lazyPage(() => import('./Pages/VideoWatch'));
const EditVideo = lazyPage(() => import('./Pages/EditVideo'));
const LoginPage = lazyPage(() => import('./Pages/LoginPage'));
const RegisterPage = lazyPage(() => import('./Pages/RegisterPage'));
const StudentProfile = lazyPage(() => import('./Pages/StudentProfile'));
const ParentPortal = lazyPage(() => import('./Pages/ParentPortal'));
const AdminStudentProfile = lazyPage(() => import('./Pages/AdminStudentProfile'));

const router = createBrowserRouter([{
  path: '/',
  element: (
    <Suspense fallback={<article className='d-flex justify-content-center align-items-center'>
      <Loading />
    </article>}>
      <RootLayout />
    </Suspense>
  ),
  errorElement: <Suspense fallback={<Loading />}><ErrorPage /></Suspense>,
  children: [
    {
      path: '/',
      element: (
        <Suspense fallback={<article className='d-flex justify-content-center align-items-center'>
          <Loading />
        </article>}>
          <HomePage />
        </Suspense>
      )
    },
    {
      path: '/Dashboard',
      element: (
        <Suspense fallback={<article className='d-flex justify-content-center align-items-center'>
          <Loading />
        </article>}>
          <Dashboard />
        </Suspense>
      )
    },
    {
      path: '/FirstSecondary',
      element: (
        <Suspense fallback={<article className='d-flex justify-content-center align-items-center'>
          <Loading />
        </article>}>
          <FirstSecondary />
        </Suspense>
      )
    },
    {
      path: '/FirstSecondary/:id',
      element: (
        <Suspense fallback={<article className='d-flex justify-content-center align-items-center'>
          <Loading />
        </article>}>
          <ProtectedRoute redirectMessage="يجب تسجيل الدخول أولاً لمشاهدة الكورسات">
            <VideoAccess />
          </ProtectedRoute>
        </Suspense>
      )
    },
    {
      path: '/SecondSecondary',
      element: (
        <Suspense fallback={<article className='d-flex justify-content-center align-items-center'>
          <Loading />
        </article>}>
          <SecondSecondary />
        </Suspense>
      )
    },
    {
      path: '/SecondSecondary/:id',
      element: (
        <Suspense fallback={<article className='d-flex justify-content-center align-items-center'>
          <Loading />
        </article>}>
          <ProtectedRoute redirectMessage="يجب تسجيل الدخول أولاً لمشاهدة الكورسات">
            <VideoAccess />
          </ProtectedRoute>
        </Suspense>
      )
    },
    {
      path: '/ThirdSecondary',
      element: (
        <Suspense fallback={<article className='d-flex justify-content-center align-items-center'>
          <Loading />
        </article>}>
          <ThirdSecondary />
        </Suspense>
      )
    },
    {
      path: '/ThirdSecondary/:id',
      element: (
        <Suspense fallback={<article className='d-flex justify-content-center align-items-center'>
          <Loading />
        </article>}>
          <ProtectedRoute redirectMessage="يجب تسجيل الدخول أولاً لمشاهدة الكورسات">
            <VideoAccess />
          </ProtectedRoute>
        </Suspense>
      )
    },
    {
      path: '/Statistics',
      element: (
        <Suspense fallback={<article className='d-flex justify-content-center align-items-center'>
          <Loading />
        </article>}>
          <Statistics />
        </Suspense>
      )
    },
    {
      path: '/Statistics/:id',
      element: (
        <Suspense fallback={<article className='d-flex justify-content-center align-items-center'>
          <Loading />
        </article>}>
          <ProtectedRoute redirectMessage="يجب تسجيل الدخول أولاً لمشاهدة الكورسات">
            <VideoAccess />
          </ProtectedRoute>
        </Suspense>
      )
    },
    {
      path: '/VideoWatch',
      element: (
        <Suspense fallback={<article className='d-flex justify-content-center align-items-center'>
          <Loading />
        </article>}>
          <ProtectedRoute redirectMessage="يجب تسجيل الدخول أولاً لمشاهدة الكورسات">
            <VideoWatch />
          </ProtectedRoute>
        </Suspense>
      )
    },
    {
      path: '/videos/edit/:id',
      element: (
        <Suspense fallback={<article className='d-flex justify-content-center align-items-center'>
          <Loading />
        </article>}>
          <EditVideo />
        </Suspense>
      )
    },
    {
      path: '/login',
      element: (
        <Suspense fallback={<article className='d-flex justify-content-center align-items-center'>
          <Loading />
        </article>}>
          <LoginPage />
        </Suspense>
      )
    },
    {
      path: '/register',
      element: (
        <Suspense fallback={<article className='d-flex justify-content-center align-items-center'>
          <Loading />
        </article>}>
          <RegisterPage />
        </Suspense>
      )
    },
    {
      path: '/profile',
      element: (
        <Suspense fallback={<article className='d-flex justify-content-center align-items-center'>
          <Loading />
        </article>}>
          <StudentProfile />
        </Suspense>
      )
    },
    {
      path: '/admin/student/:id',
      element: (
        <Suspense fallback={<article className='d-flex justify-content-center align-items-center'>
          <Loading />
        </article>}>
          <AdminStudentProfile />
        </Suspense>
      )
    },
    {
      path: '/parent',
      element: (
        <Suspense fallback={<article className='d-flex justify-content-center align-items-center'>
          <Loading />
        </article>}>
          <ProtectedRoute parentOnly={true} showMessage={true} redirectMessage="يجب تسجيل الدخول بكود الطالب للوصول لصفحة ولي الأمر">
            <ParentPortal />
          </ProtectedRoute>
        </Suspense>
      )
    }
  ],
},
]);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthProvider>
    <ExamModeProvider>
      <Provider store={store}>
        <RouterProvider router={router} />
      </Provider>
    </ExamModeProvider>
  </AuthProvider>
);
